import { render, staticRenderFns } from "./TabStandorte.vue?vue&type=template&id=44463182&scoped=true"
import script from "./TabStandorte.vue?vue&type=script&lang=js"
export * from "./TabStandorte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44463182",
  null
  
)

export default component.exports